module.exports = __webpack_public_path__ + "static/img/4-5.b804bc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/4-5.png
// module id = 272
// module chunks = 0